import React, { Component } from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { Grid, Typography, Button } from '@material-ui/core';

import {
    resetFactsApplication,
    resetFactsForUser,
} from 'Console/data/applicationDetail/settings/SettingsAction';

import { selectAppId } from 'Console/data/applicationDetail/settings/SettingsSelector';

import FormInput from 'Console/components/common/form/FormInput';
import ConfirmDialog from 'Console/components/common/confirmDialog/ConfirmDialog';

const styles = (theme) => ({
    root: {
        padding: '0 24px',
        fontSize: theme.typography.pxToRem(14),
    },
    title: {
        display: 'inline-block',
        'font-weight': 'bold',
        'padding-bottom': theme.typography.pxToRem(20),
    },
    message: {
        fontSize: theme.typography.pxToRem(14),
        paddingBottom: theme.typography.pxToRem(34),
    },
    btn: {
        marginBottom: theme.typography.pxToRem(65),
    },
    formInput: {
        width: '33%',
        marginBottom: '4%',
        [theme.breakpoints.between('xs', 'sm')]: {
            width: '100%',
            marginBottom: '5%',
        },
    },
});

class Audience extends Component {
    state = {
        deleteDialogOpen: false,
    };

    handleResetFactsApplication = () => {
        this.setState({ deleteDialogOpen: false });
        const { resetFactsApplication, appId } = this.props;
        resetFactsApplication(appId, {
            success: (
                <FormattedMessage
                    id="Notification.audience.resetAllFacts.success"
                    defaultMessage="All rule facts are reset"
                />
            ),

            fail: (
                <FormattedMessage
                    id="Notification.audience.resetAllFacts.fail"
                    defaultMessage="Could not reset facts"
                />
            ),
        });
    };

    handleResetFactsForUser = () => {
        const {
            resetFactsForUser,
            appId,
            form: { getFieldValue },
        } = this.props;
        const userId = getFieldValue('audience.userId');
        resetFactsForUser(appId, userId, {
            success: (
                <FormattedMessage
                    id="Notification.audience.resetAllFacts.success"
                    defaultMessage="All rule facts are reset"
                />
            ),

            fail: (
                <FormattedMessage
                    id="Notification.audience.resetAllFacts.fail"
                    defaultMessage="Could not reset facts"
                />
            ),
        });
    };

    render() {
        const {
            classes,
            intl,
            form,
            form: { getFieldValue },
        } = this.props;

        const { deleteDialogOpen } = this.state;

        return (
            <Grid container className={classes.root}>
                <Grid item xs={12}>
                    <Grid item>
                        <Typography variant="subtitle1" className={classes.title}>
                            <FormattedMessage
                                id="Settings.audience.resetAll.title"
                                defaultMessage="Reset all rule facts"
                            />
                        </Typography>
                    </Grid>

                    <Grid item>
                        <Typography variant="body1" className={classes.message}>
                            <FormattedMessage
                                id="Settings.audience.resetAll.message"
                                defaultMessage="By clicking on the button you can reset all the facts in your space."
                            />
                        </Typography>
                    </Grid>

                    <Grid container alignItems="center">
                        <Typography variant="button">
                            <Button
                                id="yeself-button"
                                variant="contained"
                                color="primary"
                                onClick={() => this.setState({ deleteDialogOpen: true })}
                                className={classes.btn}
                            >
                                <FormattedMessage
                                    id="Buttons.audience.resetAllFacts"
                                    defaultMessage="Reset all rule facts"
                                />
                            </Button>
                        </Typography>
                    </Grid>

                    <Grid item>
                        <Typography variant="subtitle1" className={classes.title}>
                            <FormattedMessage
                                id="Settings.audience.resetFactsForUser.title"
                                defaultMessage="Reset all rule facts for user"
                            />
                        </Typography>
                    </Grid>

                    <Grid item>
                        <Typography variant="body1" className={classes.message}>
                            <FormattedMessage
                                id="Settings.audience.resetFactsForUser.message"
                                defaultMessage="By clicking on the button you can reset all the facts  for particular user"
                            />
                        </Typography>
                    </Grid>

                    <Grid className={classes.formInput}>
                        <FormInput
                            isRequired
                            fullWidth={false}
                            form={form}
                            type="text"
                            formItemKey="audience.userId"
                            placeholder={intl.formatMessage({
                                id: 'Settings.audience.resetFactsForUser.form',
                            })}
                        />
                    </Grid>

                    <Grid container alignItems="center">
                        <Typography variant="button">
                            <Button
                                id="yeself-button"
                                variant="contained"
                                color="primary"
                                onClick={this.handleResetFactsForUser}
                                className={classes.btn}
                                disabled={!getFieldValue('audience.userId')}
                            >
                                <FormattedMessage
                                    id="Buttons.audience.resetFactsForUser"
                                    defaultMessage="Reset all rule facts for user"
                                />
                            </Button>
                        </Typography>
                    </Grid>
                </Grid>

                <ConfirmDialog
                    title={intl.formatMessage({ id: 'Settings.audience.confirmDialog' })}
                    open={deleteDialogOpen}
                    content=""
                    closeAction={() => this.setState({ deleteDialogOpen: false })}
                    action={this.handleResetFactsApplication}
                    agreeLabel={intl.formatMessage({ id: 'Buttons.delete' })}
                    disagreeLabel={intl.formatMessage({ id: 'Buttons.cancel' })}
                />
            </Grid>
        );
    }
}

export default withStyles(styles)(
    connect(
        (state) => ({
            appId: selectAppId(state),
        }),
        { resetFactsApplication, resetFactsForUser }
    )(injectIntl(Audience))
);
